import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { ActionBase } from '../actions/action-base';
import { Observable, of } from 'rxjs';
import * as sharedDataActions from '../actions/shared-data.action';
import * as models from '../../shared/models';

/**
 * To invoke service method to obtain the comment response
 */

@Injectable()
export class SharedDataEffects {

    /**
 * Constructor method used to create new instance of CommnentsEffects class
 */
    constructor(private actions$: Actions) { }
    /**
     * Method used to add new Comments
     */
    // @Effect()
    // getSharedData$: Observable<Action> = this.actions$
    //     .ofType(sharedDataActions.actionTypes.SET_SHARED_DATA)
    //     .map((action: ActionBase) => action.payload)
    //     .switchMap(data => {

    //         }
    //     );
}

